









































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { routeName } from '@/constants/route.constants';
import { Breadcrumb } from '@/models/breadcrumb.model';
import AccountBreadcrumbComponent from '@/components/account/account-breadcrumb.component.vue';
import VeterinarianModule, {
  VETERINARIAN_MODULE_NAME
} from '@/store/modules/veterinarian.module';
import { getModule } from 'vuex-module-decorators';
import store from '@/store';
import { PhoneNumberType } from '@/constants/phone-number-type';
import { VeterinarianOffice } from '@/models/DTO/veterinarian-office/veterinarian-office.model';
import LoadingComponent from '@/components/shared/loading.component.vue';
import { mapState } from 'vuex';
import { BaseAPIErrorModel } from '@/models/DTO/base-api-error.model';

const veterinarianModule: VeterinarianModule = getModule(
  VeterinarianModule,
  store
);

@Component({
  components: {
    AccountBreadcrumbComponent,
    ValidationObserver,
    ValidationProvider,
    LoadingComponent
  },
  computed: {
    ...mapState(VETERINARIAN_MODULE_NAME, [
      'showLoading',
      'showButtonLoading',
      'currentVeterinarianOffice',
      'newVeterinarianOffice',
      'errorResponse'
    ])
  }
})
export default class AccountFormComponent extends Vue {
  @Prop({
    default: ''
  })
  public title: string;

  public showLoading: boolean;
  public showButtonLoading: boolean;
  public currentVeterinarianOffice: VeterinarianOffice | null;
  public newVeterinarianOffice: VeterinarianOffice | null;
  public errorResponse: BaseAPIErrorModel | null;
  public erp: string | null = '';
  public name = '';
  public phoneNumber = '';
  public address1 = '';
  public address2: string | null = '';
  public city = '';
  public state = '';
  public zipCode = '';

  public breadcrumbs: Array<Breadcrumb> = [
    {
      text: 'Create Account',
      active: true
    },
    {
      text: 'Add Users',
      active: false
    }
  ];

  public get routeName(): typeof routeName {
    return routeName;
  }

  public get accountId(): string {
    if (!this.$route.params.accountId && this.newVeterinarianOffice) {
      return this.newVeterinarianOffice.id || '';
    }

    if (this.$route.params.accountId && this.newVeterinarianOffice) {
      this.resetNewVeterinarianOffice();
    }

    return this.$route.params.accountId;
  }

  @Watch('errorResponse', { deep: true })
  private onErrorResponseChanged(value: BaseAPIErrorModel) {
    if (value) {
      const errors = value.getAllErrorMessages();
      return this.$toasted.error(errors.join());
    }
  }

  public created() {
    if (this.accountId) {
      this.getVeterinarianOffice();
    }
  }

  private async getVeterinarianOffice(): Promise<void> {
    await veterinarianModule.getVeterinarianOfficeByIdAction(this.accountId);

    if (!this.errorResponse && this.currentVeterinarianOffice) {
      // success
      this.erp = this.currentVeterinarianOffice.erpNumber;
      this.name = this.currentVeterinarianOffice.name;
      this.phoneNumber = this.currentVeterinarianOffice.phoneNumber;
      this.address1 = this.currentVeterinarianOffice.address1;
      this.address2 = this.currentVeterinarianOffice.address2;
      this.city = this.currentVeterinarianOffice.city;
      this.state = this.currentVeterinarianOffice.state;
      this.zipCode = this.currentVeterinarianOffice.zipCode;
    }
  }

  public async onSaveClick() {
    const model: VeterinarianOffice = {
      name: this.name,
      address1: this.address1,
      address2: this.address2,
      city: this.city,
      state: this.state.toUpperCase(),
      zipCode: this.zipCode,
      erpNumber: this.erp,
      phoneNumber: this.phoneNumber,
      phoneNumberTypeId: PhoneNumberType.Office, // NOTE: hard-coded
      active: true // NOTE: hard-coded
    };

    if (!this.accountId) {
      // create
      await veterinarianModule.createVeterinarianOfficeAction(model);

      if (!this.errorResponse && this.currentVeterinarianOffice) {
        // set newVeterinarianOffice to maintain the wizard if they decide to make changes
        await veterinarianModule.newVeterinarianOfficeAction({
          ...this.currentVeterinarianOffice
        });

        this.$router.push({ name: routeName.admin.addUsers });
      }
    } else {
      // edit
      await veterinarianModule.editVeterinarianOfficeAction({
        id: this.accountId,
        ...model
      });

      if (!this.errorResponse && this.currentVeterinarianOffice) {
        // check if editing a office through the creation wizard and redirect appropriately
        if (this.newVeterinarianOffice) {
          await veterinarianModule.newVeterinarianOfficeAction({
            ...this.currentVeterinarianOffice
          });

          this.$router.push({ name: routeName.admin.addUsers });
        } else {
          this.$router.push({ name: routeName.admin.accounts });
        }
      }
    }
  }

  public resetNewVeterinarianOffice() {
    veterinarianModule.newVeterinarianOfficeAction(null);
  }
}
